<div class="dashboard-widget-card__header">
  <div class="dashboard-widget-card__title-row">
    <button
      type="button"
      class="widget-drag-handle"
      [class.widget-drag-handle--active]="isEditMode"
      mat-icon-button
      aria-label="Mover widget"
      matTooltip="Mover widget"
      matTooltipShowDelay="400">
      <mat-icon>drag_indicator</mat-icon>
    </button>
    <span
      class="dashboard-widget-card__title"
      [matTooltip]="title"
      matTooltipShowDelay="600"
      matTooltipPosition="above">
      {{ title }}
    </span>
    <span class="sensor-badges-wrapper">
      <span *ngFor="let label of visibleLabels" class="sensor-type-badge">{{ label }}</span>
      <span *ngIf="extraCount > 0" class="sensor-type-badge sensor-type-badge--more">+{{ extraCount }}</span>
      <span *ngIf="compactExtraCount > 0" class="sensor-type-badge sensor-type-badge--more sensor-type-badge--compact-more">+{{ compactExtraCount }}</span>
    </span>
  </div>
  <div class="dashboard-widget-card__controls">
    <span
      *ngIf="isMockPreview"
      class="preview-badge"
      matTooltip="Widget definido desde la plantilla del administrador">
      Plantilla
    </span>
    <button
      *ngIf="isEditable"
      class="widget-menu-button"
      mat-icon-button
      [matMenuTriggerFor]="widgetMenu"
      (click)="$event.stopPropagation()">
      <mat-icon>more_vert</mat-icon>
    </button>
  </div>
</div>

<mat-menu #widgetMenu="matMenu">
  <button mat-menu-item (click)="edit.emit()">Editar widget</button>
  <button *ngIf="canDelete" mat-menu-item class="menu-delete" (click)="remove.emit()">Eliminar widget</button>
</mat-menu>
